import React from "react";
import { Link } from "react-router-dom";
// import { connect } from 'react-redux';
// import { resetCounters } from '../../../actions/index';
const footer = () => {
  const produces = [
    { idProduce: "1", ProduceName: "دستگاه وایندر" },
    { idProduce: "2", ProduceName: "دستگاه فاق ماشین" },
    { idProduce: "3", ProduceName: "دستگاه چند لاکنی" },
    { idProduce: "4", ProduceName: "دستگاه اپتیک" },
    { idProduce: "5", ProduceName: "دستگاه مستر" },
    { idProduce: "6", ProduceName: "دستگاه هاب" },
  ];
  return (
    <footer className="site-footer">
      <div className="upper-footer">
        <div className="container">
          <div className="row">
            <div className="col col-md-4 col-sm-7">
              <div className="widget about-widget">
                <div className="footer-logo">
                  <img
                    src={process.env.PUBLIC_URL + "/assets/images/logo.png"}
                    alt=""
                    role="presentation"
                  />
                </div>
                <ul className="contact-info">
                  <li>
                    <span className="fa fa-home"></span> یزد، خیابان شهید مطهری،
                    مرکز فناوری اقبال، سالن موسسات، واحد C5
                  </li>
                  <li>
                    <span className="fa fa-phone"></span> 98-35-37263321+{" "}
                  </li>
                  <li>
                    <span className="fa fa-home"></span> ساعات کاری: <br />
                    شنبه تا چهارشنبه از ساعت ۷:۳۰ تا ۱۵:۰۰
                    <br />
                    پنجشنبه ۷:۳۰ تا ۱۴:۰۰
                  </li>
                </ul>
              </div>
            </div>

            <div className="col col-md-3 col-sm-6">
              <div className="widget service-links-widget">
                <h3>محصولات</h3>
                <ul>
                  {produces.map((item) => {
                    return (
                      <li key={item.idProduce}>
                        <Link
                          to={{
                            pathname: `/produce/${item.idProduce}`,
                            state: { from: "root" },
                          }}
                        >
                          {" "}
                          {item.ProduceName}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>

            <div className="col col-md-3 col-sm-6">
              <div className="widget quick-links-widget">
                <h3>لینک های مفید</h3>
                <ul>
                  <li>
                    <Link to="/">صفحه اصلی</Link>
                  </li>
                  <li>
                    <Link to="/about">درباره ما</Link>
                  </li>
                  <li>
                    <Link to="/produces">محصولات</Link>
                  </li>
                  <li>
                    <Link to="/news">خبرهای شرکت</Link>
                  </li>
                  <li>
                    <Link to="/contact">تماس با ما</Link>
                  </li>
                </ul>
                {/* <ul>
                                        <li><Link to="#">گالری</Link></li> 
                                        <li><Link to="/contact">تماس با ما</Link></li>
                                         <li><Link to="#">حریم خصوصی</Link></li> 
                                    </ul> */}
              </div>
            </div>

            <div className="col col-md-2 col-sm-5">
              {/* <img
                src={
                  process.env.PUBLIC_URL + "/assets/images/footer/Slogan.png"
                }
                alt=""
                role="presentation"
                style={{ height: "50%", width: "50%" }}
              /> */}
            </div>
          </div>
        </div>
      </div>

      <div className="copyright-info">
        <div className="container">
          <p>
            تمامی حقوق این وب سایت برای شرکت تعاونی دانش بنیان آپافن محفوظ
            میباشد &copy;
          </p>
        </div>
      </div>
    </footer>
  );
};

export default footer;
